import { createContext, PropsWithChildren } from 'react';

export type SynchronizationSummaryControllerValue = {
  onRefreshEnablement: () => void;
  onRefreshStatus: () => void;
};

export const SynchronizationSummaryControllerContext =
  createContext<SynchronizationSummaryControllerValue>({
    onRefreshEnablement: () => {},
    onRefreshStatus: () => {},
  });

type SynchronizationSummaryControllerProps =
  PropsWithChildren<SynchronizationSummaryControllerValue>;

export const SynchronizationSummaryController = (
  props: SynchronizationSummaryControllerProps,
) => {
  return (
    <SynchronizationSummaryControllerContext.Provider value={props}>
      {props.children}
    </SynchronizationSummaryControllerContext.Provider>
  );
};
